import { BDropdown } from '../BDropdown/BDropdown'
import { faFileLines } from '@fortawesome/free-solid-svg-icons/faFileLines'
import { getDataToCsvControls } from './getDataToCsvControls'

interface ImportExportDataDropdownProps {
    importFromCsv: Function
    exportToCsv: () => void
    className?: string
}

export const ImportExportDataDropdown= (props: ImportExportDataDropdownProps) => {
    const {
        importFromCsv,
        exportToCsv,
        className = '',
    } = props

    const handleExportToCsv = () => exportToCsv()
    const handleImportFromCsv = () => importFromCsv()
    const dropdownItems = getDataToCsvControls(
        handleImportFromCsv,
        handleExportToCsv
    )

    return (
        <BDropdown
            tooltip={'Import / Export data'}
            dropdownItems={dropdownItems}
            className={className + 'background-transparent text-white'}
            icon={faFileLines}
        />
    )
}
